import React, {Component, Fragment} from 'react';
import { connect }          from 'react-redux';
import Validate             from 'app/validation/validation';
import {NavLink}            from 'react-router-dom';

import './index.scss';

import * as routes from '../../../../constants/routes';

//components
import AnimatedInput from 'components/forms/animated_input';
import {setMembershipValidation} from "../../../../redux/actions";

class MembershipPopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            first_try:true,
            form:{
                id:{
                    val:'',
                    valid:false,
                    rules:['not_empty','id'],
                    errMsg:''
                },
                last_digits:{
                    val:'',
                    valid:false,
                    rules:['not_empty','last_digits'],
                    errMsg:''
                }
            },
        };
        this.animateOut  = this.animateOut.bind(this);
        this.animateIn   = this.animateIn.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
    }
    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }
    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleInput(val, name) {
        let validate = Validate(val, this.state.form[name].rules);
        let is_valid = validate.valid;
        let msg = validate.msg;
        let new_state = {...this.state.form,[name]: {...this.state.form[name], val:val, valid:is_valid, errMsg:msg}};
        this.setState({form:new_state});
    }
    handleSubmit(e) {
        e.preventDefault();
        let form_valid = true;
        let new_state = this.state.form;

        for(let field in this.state.form) {
            let validate = Validate(this.state.form[field].val, this.state.form[field].rules);
            let is_valid = validate.valid;
            let msg = validate.msg;

            new_state[field].valid = is_valid;
            new_state[field].errMsg = msg;

            if(is_valid === false) {
                form_valid = false;
            }
        }
        this.setState({form:new_state, first_try:false});

        if(form_valid) {
            this.props.sendValidation({userId: this.state.form.id.val, code: this.state.form.last_digits.val, benefit: this.props.benefitId},this.props.benefit.main.url.route);
        }
    }

    render() {

        const appStatus = this.props.benefitStatusDown;
        const showIdErrorMsg = !this.state.first_try && !this.state.form.id.valid;
        const showDigitsErrorMsg = !this.state.first_try && !this.state.form.last_digits.valid;

        if(appStatus){
            return false;
        }
        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper membership " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <div className = "popup_content">
                        <div className="top-right">
                            <button className = "x_close_icon"
                                    onClick = { () => this.animateOut() }
                                    aria-label="סגור">
                                &#120;ֹ
                            </button>
                        </div>
                        <div className="bottom-left">
                            {!appStatus &&
                            <Fragment>
                                <div className="title">{'בדיקת זכאות'}</div>
                                <div className="subtitle">{'יש להזין את מספר תעודת הזהות שלך כולל ספרת ביקורת ו-4 ספרות אחרונות של כרטיס האשראי המשויך למועדון הוט'}</div>
                                <form onSubmit={this.handleSubmit}>
                                    <AnimatedInput type="number"
                                                   name="id"
                                                   className="phone-input"
                                                   placeholder={'תעודת זהות'}
                                                   value={this.state.form.id.val}
                                                   onChange={this.handleInput}
                                                   showError={showIdErrorMsg}
                                                   errorMessage={this.state.form.id.errMsg}
                                                   pattern={"[0-9]*"}/>

                                    <AnimatedInput type="number"
                                                   name="last_digits"
                                                   className="phone-input"
                                                   placeholder={'4 ספרות אחרונות של כרטיס האשראי'}
                                                   value={this.state.form.last_digits.val}
                                                   onChange={this.handleInput}
                                                   showError={showDigitsErrorMsg}
                                                   errorMessage={this.state.form.last_digits.errMsg}
                                                   pattern={"[0-9]*"}/>
                                    <button type="submit"
                                            className="green-button submit-button">{'כניסה לאתר'}</button>
                                    <span className='error-massage'>{this.props.errorMsg}</span>
                                    {this.props.errorMsg !== '' && <NavLink className='contact-span' to={routes.contact} onClick={() => this.animateOut()}>{this.props.translations['membership_check_contact']}</NavLink>}
                                </form>
                            </Fragment>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.PopTrans,
        translations: store.config.Translations,
        benefitStatusDown: store.data.VIPBenefitDown,
        benefit: store.data.BenefitPage,
        errorMsg: store.data.vipBenefitErrMsg,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        sendValidation: (payload, route) =>dispatch(setMembershipValidation(payload, route)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(MembershipPopup);